import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import HotList from "./components/HotList";
import Collections from "./components/Collections";
import Timeline from "./components/Timeline";
import Featured from "./components/Featured";
import DownloadCta from "./components/DownloadCta";
import AboutFaq from "./components/AboutFaq";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <HotList />
        <Collections />
        <Timeline />
        <Featured />
        <DownloadCta />
        <AboutFaq />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}